import { ComponentProps } from "react";

import { CreateClientForm } from "@components/Forms";

import { Card } from "@design-system/Card/Card";

type Props = {
  onCreateClientSuccess?: ComponentProps<
    typeof CreateClientForm
  >["onCreateClientSuccess"];
};

export const CreateClientCard = ({ onCreateClientSuccess }: Props) => {
  return (
    <Card>
      <Card.Header>
        <Card.Header.Title>Create client</Card.Header.Title>
      </Card.Header>
      <Card.Body>
        <CreateClientForm onCreateClientSuccess={onCreateClientSuccess} />
      </Card.Body>
    </Card>
  );
};
